export default __webpack_public_path__ + "static/purple-paper-9602a7ca849324a42883d45230ca4abb.jpg";